module.exports = __webpack_public_path__ + "img/map_8.32cd752a.webp";